<svg
  (mouseenter)="mouseEnter()"
  (mouseleave)="mouseLeave()"
  [attr.height]="height"
  [attr.width]="width"
  [class.cursor-pointer]="isButton"
  fill="none"
  viewBox="0 0 13 8"
>
  <path
    [attr.stroke]="color"
    d="M1 7L6.5 2L12 7"
    stroke-width="2"
  />
</svg>
